import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import BranchList from "./branchList"

const BranchListContainer = () => {

 
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <BranchList  />
        </>
      </div>
    </div>
  )
}

export default BranchListContainer